'use client'

import { TranslationsProvider } from '@patrianna/core-components'
import { SerwistProvider } from '@serwist/turbopack/react'
import { Provider } from 'react-redux'

import VerifyLocationConfigProvider from 'app/(pages)/location/components/VerifyLocationConfigProvider'
import { NavigationProvider } from 'containers/NavigationProvider'
import formValidatorsContent from 'prismic-translates/form-validators.json'
import content from 'prismic-translates/location-verification.json'
import store from 'src/store'

import type { ReactNode } from 'react'

type AppPropsWithLayout = {
  children: ReactNode
}

const defaultPrismicLang = 'en-dv'
const translationsCache = {
  [defaultPrismicLang]: { locationVerification_enDv: content, formValidators_enDv: formValidatorsContent },
}

export function Providers({ children }: AppPropsWithLayout) {
  return (
    <SerwistProvider swUrl='/serwist/sw.js' options={{ type: 'classic' }}>
      <Provider store={store}>
        <TranslationsProvider prismicLang={defaultPrismicLang} translationsCache={translationsCache}>
          <NavigationProvider>
            <VerifyLocationConfigProvider>{children}</VerifyLocationConfigProvider>
          </NavigationProvider>
        </TranslationsProvider>
      </Provider>
    </SerwistProvider>
  )
}
